import Highlighter, { FindChunks, Chunk } from 'react-highlight-words';
import { useGridApiContext, GridRenderCellParams } from '@mui/x-data-grid-pro';

export const DataGridHightlightSearchQueryCellRender = ({ field, value }: GridRenderCellParams) => {
  const apiRef = useGridApiContext();
  const filterModel = apiRef.current.state.filter.filterModel;

  const searchItem =
    filterModel.items.find((item) => item.columnField === 'all') ||
    filterModel.items.find((item) => item.columnField === field);

  return (searchItem?.columnField === 'all' || searchItem?.columnField === field) && searchItem.value ? (
    <Highlighter
      className='MuiDataGrid-cellContent'
      searchWords={[searchItem.value]}
      autoEscape={true}
      textToHighlight={value}
      findChunks={searchItem.operatorValue === 'exact' ? findExactMatch : undefined}
    />
  ) : (
    <span className='MuiDataGrid-cellContent'>{value}</span>
  );
};

/**
 *
 * Based on default FindChunks in react-highlight-words package
 * https://github.com/bvaughn/highlight-words-core/blob/master/src/utils.js#L80
 *
 */
const findExactMatch = ({ caseSensitive, searchWords, textToHighlight, autoEscape }: FindChunks): Chunk[] => {
  return searchWords
    .filter((searchWord) => searchWord) // Remove empty words
    .reduce<Chunk[]>((chunks, searchWord) => {
      const regex = new RegExp(
        `^${autoEscape && !(searchWord instanceof RegExp) ? escapeRegExpFn(searchWord) : searchWord}$`,
        caseSensitive ? 'g' : 'gi'
      );

      let match;
      while ((match = regex.exec(textToHighlight))) {
        const start = match.index;
        const end = regex.lastIndex;
        // We do not return zero-length matches
        if (end > start) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          chunks.push({ highlight: false, start, end });
        }

        // Prevent browsers like Firefox from getting stuck in an infinite loop
        // See http://www.regexguru.com/2008/04/watch-out-for-zero-length-matches/
        if (match.index === regex.lastIndex) {
          regex.lastIndex++;
        }
      }

      return chunks;
    }, []);
};

function escapeRegExpFn(string: string): string {
  // eslint-disable-next-line no-useless-escape
  return string.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
